import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { countReportingVentureStatuses } from '~/functions/reporting';
import { usePortfolioReviewContext } from '~/functions/review';
import { ReportingRequestType, useGetUserQuery, useListReportingRequestsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var router = useRouter();
    var _usePortfolioReviewCo = usePortfolioReviewContext(),
      account = _usePortfolioReviewCo.account,
      isEditor = _usePortfolioReviewCo.isEditor,
      isAccountAdmin = _usePortfolioReviewCo.isAccountAdmin;
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return (_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser;
    });
    var isIxAdminSession = computed(function () {
      var _user$value, _user$value2;
      return Boolean((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin) && !((_user$value2 = user.value) !== null && _user$value2 !== void 0 && _user$value2.isImpersonated);
    });
    var canCreate = computed(function () {
      return isIxAdminSession.value || isEditor.value;
    });
    var canDelete = computed(function () {
      return isIxAdminSession.value || isAccountAdmin.value;
    });
    var showActionsMenu = computed(function () {
      return canCreate.value || canDelete.value;
    });
    var search = ref('');
    var showDeleteDialog = ref(false);
    var selectedRequestId = ref(null);
    var _useListReportingRequ = useListReportingRequestsQuery(computed(function () {
        return {
          fetchPolicy: 'cache-and-network'
        };
      })),
      result = _useListReportingRequ.result,
      loading = _useListReportingRequ.loading,
      refetch = _useListReportingRequ.refetch;
    onActivated(function () {
      refetch();
    });
    var requests = computed(function () {
      var _result$value$listRep, _result$value;
      return (_result$value$listRep = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listReportingRequests) !== null && _result$value$listRep !== void 0 ? _result$value$listRep : [];
    });
    var requestTypeText = function requestTypeText(requestType) {
      switch (requestType) {
        case ReportingRequestType.ImpactCarry:
          return String(proxy.$t('typeImpactCarry'));
        case ReportingRequestType.Esg:
          return String(proxy.$t('typeEsg'));
        default:
          return String(proxy.$t('typeKpi'));
      }
    };
    var filteredRequests = computed(function () {
      var q = search.value.trim().toLowerCase();
      if (!q) {
        return requests.value;
      }
      return requests.value.filter(function (r) {
        var _r$title, _r$referencePeriod, _r$ventures;
        return ((_r$title = r.title) === null || _r$title === void 0 ? void 0 : _r$title.toLowerCase().includes(q)) || ((_r$referencePeriod = r.referencePeriod) === null || _r$referencePeriod === void 0 ? void 0 : _r$referencePeriod.toLowerCase().includes(q)) || requestTypeText(r.requestType).toLowerCase().includes(q) || ((_r$ventures = r.ventures) !== null && _r$ventures !== void 0 ? _r$ventures : []).some(function (venture) {
          var _venture$venture, _venture$venture$name;
          return (_venture$venture = venture.venture) === null || _venture$venture === void 0 ? void 0 : (_venture$venture$name = _venture$venture.name) === null || _venture$venture$name === void 0 ? void 0 : _venture$venture$name.toLowerCase().includes(q);
        });
      });
    });
    var headers = computed(function () {
      var baseHeaders = [{
        text: proxy.$t('headerCreated'),
        value: 'createdAt',
        class: 'review-table-th',
        width: '152px'
      }, {
        text: proxy.$t('headerRequestType'),
        value: 'requestType',
        class: 'review-table-th',
        width: '180px'
      }, {
        text: proxy.$t('headerTitle'),
        value: 'title',
        class: 'review-table-th'
      }, {
        text: proxy.$t('headerPeriod'),
        value: 'referencePeriod',
        class: 'review-table-th',
        width: '120px'
      }, {
        text: proxy.$t('headerDue'),
        value: 'dueDate',
        class: 'review-table-th',
        width: '120px'
      }, {
        text: proxy.$t('headerCompanies'),
        value: 'companies',
        class: 'review-table-th',
        sortable: false,
        width: '240px'
      }, {
        text: proxy.$t('headerStatus'),
        value: 'status',
        class: 'review-table-th',
        sortable: false,
        width: '280px'
      }, {
        text: proxy.$t('headerActions'),
        value: 'actions',
        sortable: false,
        align: 'end',
        class: 'review-table-th',
        width: '84px'
      }];
      return baseHeaders;
    });
    var statusCounts = function statusCounts(item) {
      return countReportingVentureStatuses(item.ventures);
    };
    var formatDate = function formatDate(value) {
      if (!value) {
        return '—';
      }
      return new Date(value).toLocaleString();
    };
    var formatDueDate = function formatDueDate(value) {
      if (!value) {
        return '—';
      }
      return new Date(value).toLocaleDateString();
    };
    var goToRequest = function goToRequest(_event, _ref2) {
      var item = _ref2.item;
      router.push("/portfolio/requests/".concat(item.id));
    };
    var openDeleteDialog = function openDeleteDialog(requestId) {
      selectedRequestId.value = requestId;
      showDeleteDialog.value = true;
    };
    var onDeleteDialogInput = function onDeleteDialogInput(open) {
      showDeleteDialog.value = open;
      if (!open) {
        selectedRequestId.value = null;
      }
    };
    return {
      __sfc: true,
      proxy: proxy,
      router: router,
      account: account,
      isEditor: isEditor,
      isAccountAdmin: isAccountAdmin,
      userResult: userResult,
      user: user,
      isIxAdminSession: isIxAdminSession,
      canCreate: canCreate,
      canDelete: canDelete,
      showActionsMenu: showActionsMenu,
      search: search,
      showDeleteDialog: showDeleteDialog,
      selectedRequestId: selectedRequestId,
      result: result,
      loading: loading,
      refetch: refetch,
      requests: requests,
      requestTypeText: requestTypeText,
      filteredRequests: filteredRequests,
      headers: headers,
      statusCounts: statusCounts,
      formatDate: formatDate,
      formatDueDate: formatDueDate,
      goToRequest: goToRequest,
      openDeleteDialog: openDeleteDialog,
      onDeleteDialogInput: onDeleteDialogInput
    };
  }
});